import { useDispatch, useSelector } from 'react-redux';
import { requestBuyer } from '../features/cart/cartSlice';
import { isVdMartLocation } from '../utils/vdMartPOS';

const labels = { customer: 'Customer', vendor: 'Vendor', outlet: 'Outlet', internal_packing: 'Internal packing' };

export default function StakeholderActionButton({ className = '' }) {
  const dispatch = useDispatch();
  const location = useSelector(state => state.posUser.userInfo?.location);
  const buyer = useSelector(state => state.cart.buyer);
  const hasItems = useSelector(state => Boolean(state.cart.items?.length));
  if (!isVdMartLocation(location)) return null;
  const label = !buyer?.stakeholderType || buyer?.billingMode === 'retail' ? 'Customer billing' : buyer?.billingMode === 'franchise' ? 'Franchise customer' : buyer?.stakeholderType === 'outlet' && buyer.name ? `Dispatch: ${buyer.name}` : labels[buyer.stakeholderType];
  return <button
    type="button"
    disabled={hasItems}
    onClick={() => dispatch(requestBuyer(null))}
    aria-label={`Stakeholder: ${label}. ${hasItems ? 'Clear cart to change' : 'Change buyer'}`}
    title={hasItems ? 'Clear cart to change stakeholder' : 'Change stakeholder'}
    className={`rounded-xl border border-blue-700 bg-blue-700 px-1 py-2 text-white hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-75 ${className}`}
  >
    <span className="block text-[9px] font-medium leading-tight">Stakeholder</span>
    <span className="block whitespace-normal text-xs font-bold leading-tight">{label}</span>
  </button>;
}
